import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { IssuerAPIService } from '../services/issuer-api.service';
declare function responsiveVoiceSpeak(title, innerText): any;
declare function AcceptNotAccept(eventId): any;
declare function VoiceOnKeyPress(value, key, eventId): any;
declare function IssuerLoginHandler(): any;
declare function btnToggleNew(): any;
declare var $: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public appParentMessage: string
  constructor(private router: Router, private IssuerService: IssuerAPIService) { }

  onKeyUp(event: any) {
    debugger;
    if (event.target.id == "lblUserAgreement") {
      window.scrollTo(0, 0); // Set scroll postion top
    }

    if ((event.target.id == "txtUserName" || event.target.id == "txtPassword") && event.keyCode == 8) {
      this.CheckForValidUser();
    }
    if ((event.target.id == "Radioaccept" || event.target.id == "donotRadio") && (event.ctrlKey == true)) {
      event.preventDefault();
      return;
    }
    if (event.target.id == "txtUserName" && event.keyCode == 9) {
      btnToggleNew();
      responsiveVoiceSpeak("", "Username. Please enter your username. This is a mandatory field. Use tab to go to the next field.");
    }
    if (event.target.id == "txtPassword" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Password. Please enter your password. This is a mandatory field. Use tab to go to the next field.");
    }
    if (event.target.id == "lblUserAgreement" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "User agreement. We need you to understand our User Agreement before you can access the main application. Tab once to read the agreement. If you have already read this agreement and willing to accept then please use escape key. Submit button will be available only after agreeing or disagreeing with our user agreement.");
    }
    if (event.target.id == "lblRevisedDate" && event.keyCode == 9) {
      responsiveVoiceSpeak("", event.target.innerText);
    }
    if ((event.target.id == "lblUserAgreement1" || event.target.id == "lblUserAgreement2" || event.target.id == "lblUserAgreement3" || event.target.id == "lblUserAgreement4"
      || event.target.id == "lblUserAgreement5" || event.target.id == "lblUserAgreement6" || event.target.id == "lblUserAgreement7" || event.target.id == "lblUserAgreement8"
      || event.target.id == "lblUserAgreement9" || event.target.id == "lblUserAgreement10" || event.target.id == "lblUserAgreement11" || event.target.id == "lblUserAgreement12"
      || event.target.id == "lblUserAgreement13" || event.target.id == "lblUserAgreement14" || event.target.id == "lblUserAgreement15" || event.target.id == "lblUserAgreement16"
      || event.target.id == "lblUserAgreement17" || event.target.id == "lblUserAgreement18" || event.target.id == "lblUserAgreement19" || event.target.id == "lblUserAgreement20"
      || event.target.id == "lblUserAgreement21" || event.target.id == "lblUserAgreement22" || event.target.id == "lblUserAgreement23" || event.target.id == "lblUserAgreement24"
      || event.target.id == "lblUserAgreement25") && event.keyCode == 9) {
      responsiveVoiceSpeak("", event.target.innerText);
    }
    if (event.target.id == "Radioaccept" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "I accept. Use space bar to select this option or use tab to go the next field.");
    }
    if (event.target.id == "donotRadio" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "I don't accept. Use space bar to select this option or use tab to go to the next field.");
    }
    if (event.target.id == "termaccept" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "I have read and agree to the terms of use.");
    }
    if (event.target.id == "btnLogin" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Submit button. Press enter to login or use tab to go to the next field.");
    }
    if (event.target.id == "ForgotPassword" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Forgot Password. Select this link to reset your password or use tab to go to the footer.");
    }
    if ((event.target.id == "lblUserAgreement1" || event.target.id == "lblUserAgreement" || event.target.id == "lblUserAgreement2" || event.target.id == "lblUserAgreement3" || event.target.id == "lblUserAgreement4"
      || event.target.id == "lblUserAgreement5" || event.target.id == "lblUserAgreement6" || event.target.id == "lblUserAgreement7" || event.target.id == "lblUserAgreement8"
      || event.target.id == "lblUserAgreement9" || event.target.id == "lblUserAgreement10" || event.target.id == "lblUserAgreement11" || event.target.id == "lblUserAgreement12"
      || event.target.id == "lblUserAgreement13" || event.target.id == "lblUserAgreement14" || event.target.id == "lblUserAgreement15" || event.target.id == "lblUserAgreement16"
      || event.target.id == "lblUserAgreement17" || event.target.id == "lblUserAgreement18" || event.target.id == "lblUserAgreement19" || event.target.id == "lblUserAgreement20"
      || event.target.id == "lblUserAgreement21" || event.target.id == "lblUserAgreement22" || event.target.id == "lblUserAgreement23" || event.target.id == "lblUserAgreement24"
      || event.target.id == "lblUserAgreement25" || event.target.id == "lblRevisedDate") && event.keyCode == 27) {
      document.getElementById("Radioaccept").focus();
      responsiveVoiceSpeak("", "I accept. Use space bar to select this option or use tab to go the next field.");
    }
  };

  onkeypress(event: any) {
    debugger; 
    if (event.target.id == "txtUserName" || event.target.id == "txtPassword") {
      VoiceOnKeyPress(event.target.value, event.key, event.target.id);
    }
    this.CheckForValidUser();
  }

  CheckForValidUser() {
    debugger;
    var txtUserName = <HTMLInputElement>document.getElementById("txtUserName");
    var txtPassword = <HTMLInputElement>document.getElementById("txtPassword");
    var Radioaccept = <HTMLInputElement>document.getElementById("Radioaccept");
    var donotRadio = <HTMLInputElement>document.getElementById("donotRadio");
    var btnsubmit = <HTMLButtonElement>document.getElementById("btnLogin");
    if (txtUserName.value == "" && txtPassword.value == "" && Radioaccept.checked == false && donotRadio.checked == false) {
      btnsubmit.disabled = true;
    }
    if ((txtUserName.value != "" && txtPassword.value != "") && (Radioaccept.checked == true || donotRadio.checked == true)) {
      btnsubmit.disabled = false;
    }
    else {
      btnsubmit.disabled = true;
    }
  }

  AcceptNotAcceptclick(event: any) {
    debugger;
    if (event.ctrlKey == true) {
      event.preventDefault();
      return;
    }
    AcceptNotAccept(event.target.id);
  }

  ngOnInit() {
    debugger;
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }

    document.getElementById("divtermaccept").style.display = "none";
    var btnsubmit = <HTMLButtonElement>document.getElementById("btnLogin");
    btnsubmit.disabled = true;
    responsiveVoiceSpeak("", "This is DAC Bond issuer login page. Use tab to go to the next field.");
    localStorage.removeItem("User_Name");
    localStorage.removeItem("Last_Login");
    localStorage.removeItem("IsSelect_Obligor");
    var DomainURL = document.getElementById("APIUrl");
    DomainURL.innerText = environment.apiUrl;

  }

  // redirect to dashboard page
  onLogin(event: any) {
    IssuerLoginHandler();
  }
  IssuerLogin(event: any) {
    debugger;
    this.GetDACBond_UserLoginDetail();
    this.router.navigate(['/mydac']);
  }

  // Call Issuer IssuerBrowseObligors_ReviewToolKit APi to set obligor 1 for single , 2 for multiple obligor id
 // to display select obligor link
  GetDACBond_UserLoginDetail() {
     this.IssuerService.GetIssuerBrowseObligors_ReviewToolKit(true).subscribe(data => {
      debugger;
      if (data["length"] == 1) {
        localStorage.setItem("OBLIGOR_ID", data[0].obligorId);
        localStorage.setItem("IsSelect_Obligor", "1");
      }
      else {
        localStorage.setItem("IsSelect_Obligor", "2");
      }

     });

    // to set user name and last login 
    this.IssuerService.GetUserDetails().subscribe(data => {
      debugger;
      localStorage.setItem("User_Name", data.name);
      localStorage.setItem("Last_Login", data.lastSignInDatetime);
      this.IssuerService.GetUserDataFromLocalStorage();

    });
  }
}
